import styles from './style/ModalBlueprint.module.scss';
import React, { useEffect, useState } from 'react';

import { MdCancel, MdCheck, MdEdit, MdEditNote } from 'react-icons/md';

import Modal from '../../Utilities/Modal';
import TextField from '../../Utilities/TextField';
import Button from '../../Utilities/Button';
import Table from '../../Utilities/Table';
import { useDispatch, useSelector } from 'react-redux';
import {
  getBlueprintList,
  getPlanList,
  getPolicyList,
  getStrategyList,
  getSubPolicyList,
  patchPolicy,
  selectBlueprint,
} from '../../../store/slice/tdp/blueprint';
// import Toast from '../../Utilities/Toast';

const ModalBlueprint = ({ detail, setIsOpen, isOpen, code }) => {
  const dispatch = useDispatch();
  const { policy_lists, subpolicy_lists, strategy_lists, plan_lists } = useSelector(selectBlueprint);

  const [original, setOriginal] = useState('');
  const [text, setText] = useState('');
  const [type, setType] = useState('');
  const [step, setStep] = useState(1);

  const [choosePolicy, setChoosePolicy] = useState('');
  const [chooseStrategy, setChooseStrategy] = useState('');
  const [editData, setEditData] = useState('');
  const [error, setError] = useState(false);

  useEffect(() => {
    if (detail) {
      setOriginal(detail.category);
      setText(detail[code?.code]);

      const postObj = {
        page: 1,
        limit: 100,
        type: 'policy',
        code: code?.value,
        parent_id: detail?.id,
      };
      dispatch(getPolicyList(postObj));
    }
  }, [detail, code, dispatch]);

  useEffect(() => {
    if (choosePolicy) {
      const postObj = {
        page: 1,
        limit: 100,
        type: 'sub_policy',
        code: code?.value,
        parent_id: choosePolicy?.id,
      };
      dispatch(getSubPolicyList(postObj));
    }
  }, [choosePolicy, code, dispatch]);

  const handleCancel = () => {
    setType('');
    setStep(1);
    setChoosePolicy('');
    setChooseStrategy('');
    setError(false);
    setIsOpen(false);
  };

  const headerData = [
    {
      title: '公司目標',
      width: 45,
    },
    {
      title: '原始資料',
      width: 45,
    },
    {
      title: '',
      width: 10,
    },
  ];

  const handleSave = () => {
    if (!text || !original) {
      setError(true);
      return;
    }

    const postObj = {
      type: 'category',
      parent_id: null,
      code: code?.value,
      templates: [
        {
          id: detail.id,
          category: original,
          multilingual: text,
        },
      ],
    };

    dispatch(patchPolicy(postObj)).then(() => {
      const getObj = {
        page: 1,
        limit: 10,
        type: 'category',
        code: code?.value,
        parent_id: null,
      };
      if (getObj) dispatch(getBlueprintList(getObj));
      setIsOpen(false);
      setError(false);
    });
  };

  const handleUpdate = (type) => {
    let postObj;

    if (type === 'policy') {
      postObj = {
        type: type,
        parent_id: detail?.id,
        code: code?.value,
        templates: [
          {
            id: editData.id,
            policy: editData?.policy,
            multilingual: editData[code?.code],
          },
        ],
      };
    } else if (type === 'sub_policy') {
      postObj = {
        type: type,
        parent_id: choosePolicy?.id,
        code: code?.value,
        templates: [
          {
            id: editData.id,
            'sub-policy': editData['sub-policy'],
            multilingual: editData[code?.code],
          },
        ],
      };
    } else if (type === 'strategy') {
      postObj = {
        type: type,
        parent_id: choosePolicy?.id,
        code: code?.value,
        templates: [
          {
            id: editData.id,
            strategy_name: editData?.strategy_name,
            multilingual: editData[code?.code],
          },
        ],
      };
    } else if (type === 'plan') {
      postObj = {
        type: type,
        parent_id: chooseStrategy?.id,
        code: code?.value,
        templates: [
          {
            id: editData.id,
            strategy_name: editData?.strategy_name,
            multilingual: editData[code?.code],
          },
        ],
      };
    }

    dispatch(patchPolicy(postObj)).then(() => {
      const getObj = {
        page: 1,
        limit: 10,
        type: type,
        code: code?.value,
        parent_id: type === 'policy' ? detail?.id : type === 'plan' ? chooseStrategy?.id : choosePolicy?.id,
      };
      if (getObj) {
        if (type === 'policy') dispatch(getPolicyList(getObj));
        if (type === 'sub_policy') dispatch(getSubPolicyList(getObj));
        if (type === 'strategy') dispatch(getStrategyList(getObj));
        if (type === 'plan') dispatch(getPlanList(getObj));

        setEditData('');
      }
    });
  };

  const handleNextStep = (step, type) => {
    setStep(step);
    if (type === 'strategy') {
      setChooseStrategy('');
      const postObj = {
        page: 1,
        limit: 100,
        type: 'strategy',
        code: code?.value,
        parent_id: choosePolicy?.id,
      };
      dispatch(getStrategyList(postObj));
    }
    if (type === 'plan') {
      const postObj = {
        page: 1,
        limit: 100,
        type: 'plan',
        code: code?.value,
        parent_id: chooseStrategy?.id,
      };
      dispatch(getPlanList(postObj));
    }
  };

  return (
    <>
      <Modal size='xl' isOpen={isOpen} code={code}>
        <div className={styles.modalHeader}>
          <div className={styles.modalSubHeader}>
            <div className={styles.modalTitle}>
              <MdEditNote className={styles.modalIcon} />
              查看公司目標類別項目 ({code?.text})
            </div>
          </div>
        </div>

        {step === 1 && (
          <div className={styles.modalBody}>
            <div className={styles.colHalf}>
              <div className={styles.leftWrapper}>
                <label className={styles.labelTitle}>公司目標類別</label>
                <TextField value={text} onChange={(e) => setText(e)} error={error && !text} />
                {error && !text && <span className={styles.messageError}>未輸入原始資料目</span>}
              </div>
              <div className={styles.rightWrapper}>
                <label className={styles.labelTitle}>原始資料</label>
                <TextField value={original} onChange={(e) => setOriginal(e)} error={error && !original} fullWidth />
                {error && !original && <span className={styles.messageError}>未輸入原始資料目</span>}
              </div>
              <div className={styles.buttonWrapper}>
                <Button type='primary' title='儲存' onClick={handleSave} />
              </div>
            </div>
            <div className={styles.title}>公司目標模板列表</div>

            <Table header={headerData} type={'condensed'} nonSticky>
              {policy_lists?.total > 0 && (
                <tbody>
                  {policy_lists?.rows?.map((data, index) => (
                    <tr key={index}>
                      <td
                        className={choosePolicy?.id === data.id ? styles.active : styles.cursor}
                        width={`${headerData[0].width}%`}
                        onClick={() => setChoosePolicy(data)}
                      >
                        {data?.id === editData?.id && type === 'policy' ? (
                          <TextField onChange={(e) => setEditData({ ...editData, [code?.code]: e })} fullWidth value={editData[code?.code]} />
                        ) : (
                          data[code?.code]
                        )}
                      </td>
                      <td
                        className={choosePolicy?.id === data.id ? styles.active : styles.cursor}
                        width={`${headerData[1].width}%`}
                        onClick={() => setChoosePolicy(data)}
                      >
                        {data?.id === editData?.id && type === 'policy' ? (
                          <TextField onChange={(e) => setEditData({ ...editData, policy: e })} fullWidth value={editData?.policy} />
                        ) : (
                          <div className={styles.editWrapper}>{data?.policy}</div>
                        )}
                      </td>
                      <td className={choosePolicy?.id === data.id ? styles.active : styles.cursor} width={`${headerData[2].width}%`}>
                        <span className={styles.btnEdit}>
                          {editData?.id === data?.id && type === 'policy' ? (
                            <>
                              <Button type='pure' icon={<MdCheck className={styles.icon} />} onClick={() => handleUpdate('policy')} />
                              <Button type='pure' icon={<MdCancel className={styles.icon} />} onClick={() => setEditData('')} />
                            </>
                          ) : (
                            <Button
                              type='pure'
                              icon={<MdEdit className={styles.icon} />}
                              onClick={() => {
                                setEditData(data);
                                setType('policy');
                              }}
                            />
                          )}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>

            <div className={styles.title}>目標細節模板列表</div>

            <Table header={headerData} type={'condensed'} nonSticky>
              {subpolicy_lists?.total > 0 && (
                <tbody>
                  {subpolicy_lists?.rows?.map((data, index) => (
                    <tr key={index}>
                      <td width={`${headerData[0].width}%`}>
                        {data?.id === editData?.id && type === 'sub_policy' ? (
                          <TextField value={editData[code?.code]} onChange={(e) => setEditData({ ...editData, [code?.code]: e })} fullWidth />
                        ) : (
                          data[code?.code]
                        )}
                      </td>
                      <td width={`${headerData[1].width}%`}>
                        {data?.id === editData?.id && type === 'sub_policy' ? (
                          <TextField value={editData['sub-policy']} onChange={(e) => setEditData({ ...editData, 'sub-policy': e })} fullWidth />
                        ) : (
                          <div className={styles.editWrapper}>{data['sub-policy']}</div>
                        )}
                      </td>
                      <td width={`${headerData[2].width}%`}>
                        <span className={styles.btnEdit}>
                          {editData?.id === data?.id && type === 'sub_policy' ? (
                            <>
                              <Button type='pure' icon={<MdCheck className={styles.icon} />} onClick={() => handleUpdate('sub_policy')} />
                              <Button type='pure' icon={<MdCancel className={styles.icon} />} onClick={() => setEditData('')} />
                            </>
                          ) : (
                            <Button
                              type='pure'
                              icon={<MdEdit className={styles.icon} />}
                              onClick={() => {
                                setEditData(data);
                                setType('sub_policy');
                              }}
                            />
                          )}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </div>
        )}

        {step === 2 && (
          <div className={styles.modalBody}>
            <div className={styles.title}>策略模板列表</div>

            <Table header={headerData} type={'condensed'} nonSticky>
              {strategy_lists?.total > 0 && (
                <tbody>
                  {strategy_lists?.rows?.map((data, index) => (
                    <tr key={index}>
                      <td
                        className={chooseStrategy?.id === data.id ? styles.active : styles.cursor}
                        width={`${headerData[0].width}%`}
                        onClick={() => setChooseStrategy(data)}
                      >
                        {data?.id === editData?.id && type === 'strategy' ? (
                          <TextField onChange={(e) => setEditData({ ...editData, [code?.code]: e })} fullWidth value={editData[code?.code]} />
                        ) : (
                          data[code?.code]
                        )}
                      </td>
                      <td
                        className={chooseStrategy?.id === data.id ? styles.active : styles.cursor}
                        width={`${headerData[1].width}%`}
                        onClick={() => setChooseStrategy(data)}
                      >
                        {data?.id === editData?.id && type === 'strategy' ? (
                          <TextField onChange={(e) => setEditData({ ...editData, strategy_name: e })} fullWidth value={editData?.strategy_name} />
                        ) : (
                          <div className={styles.editWrapper}>{data?.strategy_name}</div>
                        )}
                      </td>
                      <td className={chooseStrategy?.id === data.id ? styles.active : styles.cursor} width={`${headerData[2].width}%`}>
                        <span className={styles.btnEdit}>
                          {editData?.id === data?.id && type === 'strategy' ? (
                            <>
                              <Button type='pure' icon={<MdCheck className={styles.icon} />} onClick={() => handleUpdate('strategy')} />
                              <Button type='pure' icon={<MdCancel className={styles.icon} />} onClick={() => setEditData('')} />
                            </>
                          ) : (
                            <Button
                              type='pure'
                              icon={<MdEdit className={styles.icon} />}
                              onClick={() => {
                                setEditData(data);
                                setType('strategy');
                              }}
                            />
                          )}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </div>
        )}

        {step === 3 && (
          <div className={styles.modalBody}>
            <div className={styles.title}>部門行動計畫模板列表</div>

            <Table header={headerData} type={'condensed'} nonSticky>
              {plan_lists?.total > 0 && (
                <tbody>
                  {plan_lists?.rows?.map((data, index) => (
                    <tr key={index}>
                      <td className={chooseStrategy?.id === data.id ? styles.active : styles.cursor} width={`${headerData[0].width}%`}>
                        {data?.id === editData?.id && type === 'plan' ? (
                          <TextField onChange={(e) => setEditData({ ...editData, [code?.code]: e })} fullWidth value={editData[code?.code]} />
                        ) : (
                          data[code?.code]
                        )}
                      </td>
                      <td className={chooseStrategy?.id === data.id ? styles.active : styles.cursor} width={`${headerData[1].width}%`}>
                        {data?.id === editData?.id && type === 'plan' ? (
                          <TextField onChange={(e) => setEditData({ ...editData, strategy_name: e })} fullWidth value={editData?.strategy_name} />
                        ) : (
                          <div className={styles.editWrapper}>{data?.strategy_name}</div>
                        )}
                      </td>
                      <td className={chooseStrategy?.id === data.id ? styles.active : styles.cursor} width={`${headerData[2].width}%`}>
                        <span className={styles.btnEdit}>
                          {editData?.id === data?.id && type === 'plan' ? (
                            <>
                              <Button type='pure' icon={<MdCheck className={styles.icon} />} onClick={() => handleUpdate('plan')} />
                              <Button type='pure' icon={<MdCancel className={styles.icon} />} onClick={() => setEditData('')} />
                            </>
                          ) : (
                            <Button
                              type='pure'
                              icon={<MdEdit className={styles.icon} />}
                              onClick={() => {
                                setEditData(data);
                                setType('plan');
                              }}
                            />
                          )}
                        </span>
                      </td>
                    </tr>
                  ))}
                </tbody>
              )}
            </Table>
          </div>
        )}

        <div className={`${styles.modalFooter} ${styles.right}`}>
          <span style={{ marginRight: '8px' }}>
            <Button type='quaternary' title='關閉' onClick={handleCancel} style={{ marginRight: '8px' }} />
          </span>
          {step === 1 && <Button type='primary' title='前往策略模板' disabled={!choosePolicy} onClick={() => handleNextStep(2, 'strategy')} />}
          {step === 2 && (
            <>
              <span style={{ marginRight: '8px' }}>
                <Button type='quaternary' title='回上一步' onClick={() => setStep(1)} />
              </span>
              <Button type='primary' title='前往部門行動計畫模板' disabled={!chooseStrategy} onClick={() => handleNextStep(3, 'plan')} />
            </>
          )}
          {step === 3 && (
            <>
              <Button type='quaternary' title='回上一步' onClick={() => setStep(2)} />
            </>
          )}
        </div>
      </Modal>

      {/* <Toast show={false} title={'職能項目已更改'} subtitle={`${detail.category} - ${item}`} /> */}
    </>
  );
};

export default ModalBlueprint;
